import { html, LitElement } from "lit";
import { customElement, property } from 'lit/decorators.js';
import { when } from "lit/directives/when.js";
import '../icon';
import style from './footer-row.scss';

/**
 * Single item of footer.
 *
 * @slot - footer item content
 */

@customElement('footer-row')
export class FooterRow extends LitElement {
    static override styles = style;

    /**
     * Optional icon prepending footer item.
     */
    @property() icon = '';

    override render() {
        return html`
            <div>
                ${when(this.icon, () => html`<usos-icon icon-name=${this.icon}></usos-icon>`)}
                <div>
                    <slot></slot>
                </div>
            </div>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'footer-row': FooterRow
    }
}
